import { LoadingText } from '@web/components/LoadingText'
import { Icon } from '@web/components/ui/icons'
import type { ComponentProps, ReactNode } from 'react'

/** Shared icon column and copy treatment for inline session activity. */
export function InlineStatus({
  icon,
  loading = false,
  failed = false,
  children,
  testId,
}: {
  icon: ComponentProps<typeof Icon>['name']
  loading?: boolean
  failed?: boolean
  children: ReactNode
  testId?: string
}) {
  return (
    <div
      className="inline-status-row"
      data-testid={testId}
      role={loading ? 'status' : undefined}
      aria-live={loading ? 'polite' : undefined}
    >
      <span className="inline-status-icon">
        <Icon
          name={icon}
          size={16}
          className={failed ? 'text-danger' : 'text-muted'}
        />
      </span>
      <div className="min-w-0">
        {loading ? <LoadingText>{children}</LoadingText> : children}
      </div>
    </div>
  )
}
